import React, { Component } from 'react';
import CarouselGroup from '../carousel-group/CarouselGroup';
import InfoBox from '../info-box/InfoBox';
import { cloudinaryLink } from '../listing-image/ListingImage';

class ListingThumbnail extends Component {
  renderMeta () {
    const { seoMeta } = this.props;
    const { title, description, reviewValue, reviewCount, city, state, image } = seoMeta;
    const hasReviews = (reviewValue && reviewCount) && parseFloat(reviewValue) > 0 && parseInt(reviewCount) > 0;
    const hasAddress = city && state;
    const imageURLBase = `${cloudinaryLink}/${image}`;
    return (
      <div>
        <meta itemProp="name" content={ title } />
        { description && <meta itemProp="description" content={ description } /> }
        { hasReviews &&
            <div itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
              <meta itemProp="ratingValue" content={ reviewValue } />
              <meta itemProp="reviewCount" content={ reviewCount } />
            </div>
        }
        { hasAddress &&
            <div itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
              <meta itemProp="addressLocality" content={ city } />
              <meta itemProp="addressRegion" content={ state } />
            </div>
        }
        { image &&
          <meta itemProp="image" content={`${imageURLBase}/${image}`} />
        }
      </div>
    );
  }

  render () {
    const {
      mouseOver,
      mouseOut,
      seoMeta,
      isMap,
      hideInfoBox = false
    } = this.props;
    const classList = `Listing-Thumbnail ${isMap ? 'is-map' : ''}`;

    return (
      <div itemScope itemType="http://schema.org/LocalBusiness">
        { seoMeta && this.renderMeta() }
        <div className={ classList } onMouseOver={ mouseOver } onMouseOut={ mouseOut }>
          <CarouselGroup { ...this.props } />
          { !hideInfoBox && <InfoBox { ...this.props } /> }
        </div>
      </div>
    );
  }
}

export default ListingThumbnail;
